import { ScoopText } from '../../../ui'
import { useHelpBotContext } from '../../../../context/HelpBotContext'
import styles from './HelpBotNudge.module.scss'

/**
 * HelpBotNudge - A contextual prompt bubble that appears near the HelpBot FAB
 *
 * @param {Object} props
 * @param {boolean} props.isVisible - Whether the nudge is visible
 * @param {Object} props.config - Nudge configuration { message, prompt }
 * @param {Function} props.onDismiss - Called when user dismisses the nudge
 * @param {Function} props.onDismissForever - Called when user selects "Don't show again"
 * @param {string} props.position - FAB position ('left' or 'right')
 */
export const HelpBotNudge = ({
    isVisible,
    config,
    onDismiss,
    onDismissForever,
    position = 'left',
}) => {
    const { sendPrompt } = useHelpBotContext()

    if (!isVisible || !config) {
        return null
    }

    const handleClick = () => {
        sendPrompt(config.prompt)
        onDismiss()
    }

    const handleDismissForever = (e) => {
        e.stopPropagation()
        onDismissForever()
    }

    const handleDismiss = (e) => {
        e.stopPropagation()
        onDismiss()
    }

    const nudgeClassName = [styles.nudge, position === 'left' ? styles.left : styles.right]
        .filter(Boolean)
        .join(' ')

    return (
        <div className={nudgeClassName} role="tooltip" aria-label="HelpBot suggestion">
            <button className={styles.messageButton} onClick={handleClick} type="button">
                <ScoopText className={styles.message}>{config.message}</ScoopText>
            </button>

            <div className={styles.actions}>
                <button type="button" onClick={handleDismiss} className={styles.actionButton}>
                    Dismiss
                </button>
                <span className={styles.separator}>·</span>
                <button
                    type="button"
                    onClick={handleDismissForever}
                    className={styles.actionButton}
                >
                    Never show again
                </button>
            </div>
        </div>
    )
}
